import { render, staticRenderFns } from "./notepadOwnerRepair.vue?vue&type=template&id=37addace"
import script from "./notepadOwnerRepair.vue?vue&type=script&lang=js"
export * from "./notepadOwnerRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports